/**
 * # as-portal-target
 *
 * Receives content from matching `<as-portal>` elements.
 * Matched by the `name` attribute on the target and `target` attribute on the portal.
 *
 * ## Attributes
 * - `name`: Identifier that portals reference via their `target` attribute
 */
export class AsPortalTarget extends HTMLElement {
  static get observedAttributes() {
    return ['name'];
  }

  connectedCallback() {
    window.dispatchEvent(new CustomEvent('as-portal-target-ready', {
      detail: { name: this.getAttribute('name'), element: this }
    }));
  }
}

if (!customElements.get('as-portal-target')) {
  customElements.define('as-portal-target', AsPortalTarget);
}
